import { Input, InputProps } from '@chakra-ui/react';
import { ForwardedRef, forwardRef } from 'react';
import { Fax } from '../icons/fax';
import HierarchyTag from '../tags/hierarchy-tag';
import { InputGroup } from '../ui/input-group';

export interface FaxInputProps extends Omit<InputProps, 'placeholder' | 'type' | 'maxLength'> {
    primary?: boolean;
    showIcon?: boolean;
}

const formatPhoneNumber = (value: string) => {
    const phoneNumber = value.replace(/\D/g, '');
    const length = phoneNumber.length;

    if (length < 4) {
        return phoneNumber;
    }
    if (length < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const faxInput = (
    { primary, showIcon = true, value, onChange, ...inputProps }: FaxInputProps,
    ref: ForwardedRef<HTMLInputElement | null>,
) => {
    const formattedValue = formatPhoneNumber(value ? String(value) : '');

    return (
        <InputGroup
            width="full"
            startElement={showIcon && <Fax data-testid="icon" />}
            endElement={primary && <HierarchyTag data-testid="primary-badge">primary</HierarchyTag>}>
            <Input
                {...inputProps}
                ref={ref}
                type="text"
                data-testid="phone-input-field"
                placeholder="(XXX) XXX-XXXX"
                value={formattedValue}
                onChange={(e) => {
                    const unformattedValue = e.target.value.replace(/\D/g, '');
                    e.target.value = unformattedValue.slice(0, 10);
                    onChange?.(e);
                }}
            />
        </InputGroup>
    );
};

faxInput.displayName = 'PhoneInput';

export const FaxInput = forwardRef(faxInput);
